import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CustomerService from "services/CustomerService";

const initialState = {
  loading: false,
  customers: [],
  total: 0,
  stats: {
    total: 0,
    registered: 0,
    guests: 0,
    walk_in: 0,
    with_orders: 0,
    total_revenue: 0,
  },
  message: "",
  showMessage: false,
  filters: {
    search: null,
  },
};

export const getCustomers = createAsyncThunk(
  "customers/getCustomers",
  async ({ page = 1, pagelimit = 20, filters = {} }, { rejectWithValue }) => {
    try {
      const response = await CustomerService.getCustomers(
        page,
        pagelimit,
        filters,
      );
      return {
        customers: response.data || [],
        total: response.total || 0,
        stats: response.stats || initialState.stats,
        filters,
      };
    } catch (err) {
      return rejectWithValue(err.message || "Error fetching customers");
    }
  },
);

const customerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    clearMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomers.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.customers = payload.customers;
        state.total = payload.total;
        state.stats = payload.stats || state.stats;
        state.filters = payload.filters || state.filters;
        state.showMessage = false;
      })
      .addCase(getCustomers.rejected, (state, { payload }) => {
        state.loading = false;
        state.message = payload;
        state.showMessage = true;
      });
  },
});

export const { clearMessage } = customerSlice.actions;
export default customerSlice.reducer;
